import styled from '@emotion/styled';
import { colors } from 'application/theme/palette';
import { RadioButtonStyledProps } from './modules';

export const RadioButtonStyled = styled.div<RadioButtonStyledProps>`
  display: flex;
  align-items: center;
  box-sizing: border-box;

  > label {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    color: ${({ disabled }) => (disabled ? colors.grey300 : colors.grey900)};
    font-family: Unica77;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.08px;
    margin-left: 4px;
  }

  input[type='radio'] {
    -webkit-appearance: none;
    appearance: none;
    background-color: ${colors.white};

    color: currentColor;
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    border: 2px solid
      ${({ checked }) => (checked ? colors.blue700 : colors.grey300)};
    border-radius: 50%;
    display: grid;
    place-content: center;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }

  input[type='radio']::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    transform: ${({ checked }) => (checked ? 'scale(1)' : 'scale(0)')};
    transition: 120ms transform ease-in-out;
    box-shadow: inset 10px 10px
      ${({ disabled }) => (disabled ? colors.grey300 : colors.blue700)};
    border-radius: 100px;
    background: ${colors.white};
  }

  input[type='radio']:checked {
    border: 2px solid
      ${({ disabled }) => (disabled ? colors.grey300 : colors.blue700)};

    &::before {
      transform: scale(1);
    }
  }
`;
